import { CellParams, defaultColActionDef, defaultColDef, TABLE_ACTION } from '@qrios/frontend-library';
import { predefinedColumns } from '../../../../../common/table/columns';
import { nortadaLogger } from '../../../../../common/logger';
import { renderAppDebugMode, renderStatus } from '../../ussd/apps/columns';

export const columns = [
  {
    ...defaultColDef,
    flex: 1,
    field: 'appId',
    headerName: 'Id',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'appUrl',
    headerName: 'URL',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'debugEnabled',
    headerName: 'Debug mode',
    minWidth: 150,
    sortable: true,
    renderCell: (cell: CellParams) => {
      if (typeof cell.value === 'boolean') {
        return renderAppDebugMode(cell.value);
      }
      return nortadaLogger.critical(
        `Error while rendering "Debug mode" table cell in WAP Apps.
        Received ${typeof cell.value} type but need to be boolean.`
      );
    }
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'status',
    headerName: 'Status',
    minWidth: 120,
    sortable: true,
    renderCell: (cell: CellParams) => {
      if (typeof cell.value === 'string') {
        return renderStatus(cell.value);
      }
      return nortadaLogger.critical(
        `Error while rendering "Status" table cell in WAP Apps.
        Received ${typeof cell.value} type but need to be string.`
      );
    }
  },
  {
    ...defaultColActionDef([TABLE_ACTION.EDIT]),
    minWidth: 85
  },
  predefinedColumns.date({ field: 'createDate', hide: true })
];
